import { isFunction } from 'lodash';

import { PermissionService } from '@app/shared/services';
import { DndItem } from '../types/xux-dnd-common.types';

export const isDndItemNoPermission = (
  item: Partial<DndItem>,
  options: {
    permissionService: PermissionService;
  },
): boolean => {
  if (isFunction(item.permissionChecker)) {
    return !item.permissionChecker(options.permissionService);
  }

  return false;
};

export const isDndItemHidden = (
  item: Partial<DndItem>,
  options: {
    permissionService: PermissionService;
  },
) => {
  return isDndItemNoPermission(item, options) || item.hidden;
};
